import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.656 4.75c3.5 0 6.344 2.844 6.344 6.344 0 .383-.3.656-.656.656a.63.63 0 0 1-.657-.656c0-2.762-2.269-5.031-5.03-5.031A.63.63 0 0 1 12 5.406c0-.355.273-.656.656-.656m.219 5.25a.9.9 0 0 1 .875.875c0 .492-.41.875-.875.875a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875M12 8.031c0-.355.273-.656.656-.656a3.723 3.723 0 0 1 3.719 3.719c0 .383-.3.656-.656.656a.63.63 0 0 1-.656-.656 2.43 2.43 0 0 0-2.407-2.406A.63.63 0 0 1 12 8.03M8.2 4.805c.519-.137 1.093.11 1.284.629l1.094 2.625c.192.437.082.957-.3 1.257l-1.34 1.121a9.2 9.2 0 0 0 4.374 4.376l1.122-1.34c.3-.383.82-.493 1.257-.301l2.625 1.094c.493.191.766.765.63 1.285l-.657 2.406a1.08 1.08 0 0 1-1.039.793A12.23 12.23 0 0 1 5 6.5c0-.492.328-.902.793-1.04z"
    }, null, -1)
  ]))]))
}
export default { render: render }